var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportScreenIcon = function SvgSupportScreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M4.002 9.501a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333M4.002 11.168c-1.048 0-1.964.622-2.456 1.548-.201.379.117.785.547.785H5.91c.43 0 .749-.406.547-.785-.492-.926-1.407-1.548-2.455-1.548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    d: "M4.002 9.501a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM4.002 11.168c-1.048 0-1.964.622-2.456 1.548-.201.379.117.785.547.785H5.91c.43 0 .749-.406.547-.785-.492-.926-1.407-1.548-2.455-1.548Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
  })));
};
export { SvgSupportScreenIcon as ReactComponent };
export default __webpack_public_path__ + "8c15d30997772e64d0e7813e6aa91424.svg";